import { RevertToDefaultLabelDialog } from '@tableau/catalog-ui-temp';
import React from 'react';
import { call, put } from 'redux-saga/effects';

import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { RevertToDefaultLabelAction } from '~src/catalog/actions/labels/RevertToDefaultLabelAction';
import { CatalogProviders } from '~src/catalog/CatalogProviders';
import { CatalogTelemetryProvider } from '~src/catalog/DataCatalogTelemetry';
import { ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { reloadSpaceIfUpdatingCurrentSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';

import { Messages } from '../../../codegen/Localize';

export function* handleRevertToDefaultLabelValue(action: RevertToDefaultLabelAction) {
    try {
        yield call(openRevertToDefaultLabel, action);

        const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
        if (!maybeReloaded) {
          yield put(requestSpaceContents());
        }
    } catch(e) {
        yield put(requestFailed(e, Messages.errorUnknown()));
    }
}


export function openRevertToDefaultLabel(action: RevertToDefaultLabelAction) {

    return ReactModalService.openCustom(({ close }) => {
      return (
      <CatalogProviders>
        <CatalogTelemetryProvider>
          <RevertToDefaultLabelDialog
            labelValue={action.item.value}
            category={action.item.category}
            hideDialog={close}
            getAnchorClientRect={undefined}
          />
        </CatalogTelemetryProvider>
      </CatalogProviders>
      );
    }).result;
}
